var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmailOpenOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.03 6.29063L12 0.640625L2.97 6.29063C2.39 6.64062 2 7.27063 2 8.00063V18.0006C2 19.1006 2.9 20.0006 4 20.0006H20C21.1 20.0006 22 19.1006 22 18.0006V8.00063C22 7.27063 21.61 6.64062 21.03 6.29063ZM20 18.0006H4V10.0006L12 15.0006L20 10.0006V18.0006ZM12 13.0006L4 8.00063L12 3.00063L20 8.00063L12 13.0006Z",
    fill: "#2783EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailOpenOutline);
export default __webpack_public_path__ + "static/media/icon-email-open-outline.bd7ffadbb67f07298ef1241f3ffc0e0e.svg";
export { ForwardRef as ReactComponent };